<!-- <mat-card *ngIf="policyHolder" class="policy-card">
  <mat-card-header>
    <mat-card-title>{{ policyHolder.PolicyHolderName || 'No Name Provided' }}</mat-card-title>
    <mat-card-subtitle>
      DOB: {{ policyHolder.DOB | date:'mediumDate' }}
    </mat-card-subtitle>
  </mat-card-header>

  <mat-card-content> -->
<div>
  <h3>Address</h3>
  <p>
    {{ policyHolder.Address1 }}<br>
    {{ policyHolder.Address2 }}<br>
    {{ policyHolder.Address3 }}<br>
    {{ policyHolder.Address4 }}<br>
    {{ policyHolder.Address5 }}
  </p>
</div>
<div>
  <h3>Contact</h3>
  <p *ngIf="policyHolder.HomePhoneNumber">Home: {{ policyHolder.HomePhoneNumber }}</p>
  <p *ngIf="policyHolder.BusinessPhoneNumber">Business: {{ policyHolder.BusinessPhoneNumber }}</p>
  <p *ngIf="policyHolder.MobilePhoneNumber">Mobile: {{ policyHolder.MobilePhoneNumber }}</p>
  <p *ngIf="policyHolder.FaxNumber">Fax: {{ policyHolder.FaxNumber }}</p>
  <p *ngIf="policyHolder.Email">Email: {{ policyHolder.Email }}</p>
</div>
<!-- </mat-card-content>
</mat-card> -->